/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Builder_TagInputs */

const en_cp_builder_tag = /** @type {(inputs: Cp_Builder_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a business`)
};

const id_cp_builder_tag = /** @type {(inputs: Cp_Builder_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun bisnis`)
};

/**
* | output |
* | --- |
* | "Build a business" |
*
* @param {Cp_Builder_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_builder_tag = /** @type {((inputs?: Cp_Builder_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Builder_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_builder_tag(inputs)
	return en_cp_builder_tag(inputs)
});